export function logError(error) {
  window.DD_RUM?.onReady(function () {
    window.DD_RUM.addError(error);
  });
}

export function setUser(userProfileState) {
  window.DD_RUM?.onReady(function () {
    window.DD_RUM.setUser({
      id: userProfileState.userId,
    });
  });
}

export function clearUser() {
  window.DD_RUM?.onReady(function () {
    window.DD_RUM.clearUser();
  });
}
